import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-122">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-123">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-black/60" onClick={onClose} data-id="element-124" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="relative bg-[#FAF7F2] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden z-10" data-id="element-125">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-[#e5e0d8] bg-[#1B2A4A]" data-id="element-126">
              <h2 className="font-serif text-xl md:text-2xl font-bold text-[#F5F0E8]" data-id="element-127">
                {title}
              </h2>
              <button onClick={onClose} className="text-[#F5F0E8]/70 hover:text-[#F5F0E8] transition-colors p-1 rounded-lg hover:bg-white/10" aria-label="Cerrar" data-id="element-128">
                <X className="w-6 h-6" data-id="element-129" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(85vh-80px)] text-[#2D2A26] text-lg leading-relaxed space-y-4" data-id="element-130">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}